import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from './LotteryHomePage.module.scss';
import { resetDrawsForGame, saveGameName } from '../../store/gameSlice';
import GameList from '../../components/GameList/GameList';
import GameSetting from '../../components/GameSetting/GameSetting';
import GameTickets from '../../components/GameTickets/GameTickets';
import LottoCanvas from '../../components/LottoCanvas/LottoCanvas';
import SpecialBets from '../../components/SpecialBets/SpecialBets';
import CounterComponent from '../../components/CounterComponent/CounterComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import PopupComponent from '../../components/PopupComponent/PopupComponent';
import howToPlayIcon from '../../assets/images/howtoplay.png';
import GameBets from '../../components/GameBets/GameBets';
import { useTheme } from '../../utils/ThemeContext';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import lotterySound from '../../assets/sounds/lotteryLatest.mp3';
import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';

function LotteryHomePage() {
  const [activeGame, setActiveGame] = useState('lotto 5/90');
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [nightMode, setNightMode] = useState(false);
  const [sound, setSound] = useState(true);
  const { theme, switchTheme } = useTheme();
  const [mobilemenu, setmobilemenu] = useState('closed');
  const [btnstate, setbtnstate] = useState('');
  const [menulist, setmenulist] = useState('hidden');
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isPopupOpenStatus, setPopupOpenStatus] = useState(false);
  const [isUserInteracted, setIsUserInteracted] = useState(false);
  const audioRef = useRef(new Audio(lotterySound));


  const [jackpot, setJackpot] = useState(100);

  const dispatch = useDispatch();
  const isAnyMenuOpen = openIndex !== null;

  const draws = useSelector((state) => state.game.draws);
  const resultPick3 = useSelector((state) => state.game.resultPick3);
  const resultLotto_5_90 = useSelector((state) => state.game.resultLotto_5_90);
  const resultLotto_4_48 = useSelector((state) => state.game.resultLotto_4_48);
  const resultLotto_6_49 = useSelector((state) => state.game.resultLotto_6_49);

  const handleUserInteraction = () => {
    setIsUserInteracted(true);
    setSound(true);
  };
  useEffect(() => {
    const audio = audioRef.current;
    audio.loop = false;

    if (isUserInteracted && sound) {
      audio.play().catch((err) => console.warn('Audio play failed:', err));
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  }, [sound, isUserInteracted]);

  useEffect(() => {
    if (
      (Array.isArray(draws) &&
        draws.length > 0 &&
        Array.isArray(resultLotto_5_90) &&
        resultLotto_5_90.length > 0 &&
        draws.some((draw) => draw.gameName === theme.themeName)) ||
      (Array.isArray(draws) &&
        draws.length > 0 &&
        Array.isArray(resultLotto_4_48) &&
        resultLotto_4_48.length > 0 &&
        draws.some((draw) => draw.gameName === theme.themeName)) ||
      (Array.isArray(draws) &&
        draws.length > 0 &&
        Array.isArray(resultLotto_6_49) &&
        resultLotto_6_49.length > 0 &&
        draws.some((draw) => draw.gameName === theme.themeName)) ||
      (Array.isArray(draws) &&
        draws.length > 0 &&
        Array.isArray(resultPick3) &&
        resultPick3.length > 0 &&
        draws.some((draw) => draw.gameName === theme.themeName))
    ) {
      setPopupOpenStatus(true);
    }
  }, [
    resultLotto_5_90,
    resultLotto_4_48,
    resultLotto_6_49,
    resultPick3,
    theme.themeName,
  ]);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
    setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1199);
  };

  const openmenu = () => {
    if (mobilemenu === 'closed') {
      setmobilemenu('open');
      setbtnstate('open');
      setmenulist('visible');
      setOpenIndex(null);
    } else {
      setmobilemenu('closed');
      setbtnstate('closed');
      setmenulist('hidden');
    }
  };

  const popUpHandle = () => {
    if (isPopupOpen) {
      setPopupOpen(false);
    } else {
      setPopupOpen(true);
      setOpenIndex(null);
    }
  };

  const handleGameClick = (gameName) => {
    if (activeGame !== gameName) {
      setActiveGame(gameName);
      dispatch(saveGameName(gameName));
    }

    setmenulist('hidden');
    setPopupOpen(false);

    if (gameName === 'pick 3') {
      switchTheme('instant.pick3');
    } else if (gameName === 'lotto 5/90') {
      switchTheme('instant.lotto590');
    } else if (gameName === 'lotto 4/48') {
      switchTheme('loto');
    } else if (gameName === 'Lotto 6/49') {
      switchTheme('poolLotto');
    }
  };

  const toggleMenu = (index) => {
    if (index === 0) {
      openmenu();
    } else if (index === 2) {
      popUpHandle();
    } else {
      setOpenIndex(openIndex === index ? null : index);
      setmobilemenu('closed');
      setbtnstate('closed');
      setmenulist('hidden');
    }
  };

  useEffect(() => {
    if (menulist === 'visible') {
      document.body.classList.add('bodyOverFlow');
    } else if (menulist === 'hidden') {
      document.body.classList.remove('bodyOverFlow');
    }
  }, [menulist]);

  useEffect(() => {
    switchTheme('instant.lotto590');
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleState = (stateKey, event) => {
    event.stopPropagation();

    if (stateKey === 'nightMode') {
      setNightMode(!nightMode);
      document.body.classList.toggle('night-mode', !nightMode);
    }

    if (stateKey === 'sound') {
      setSound(!sound);
    }
  };

  const gamesData = {
    instant: [{ type: 'solid', numbers: [3], GameName: 'pick 3' }],
    lotto: [
      {
        type: 'solid_outer',
        numbers: [5, 90],
        typeColor: 'left_right',
        GameName: 'lotto 5/90',
      },
      {
        type: 'solid_outer',
        numbers: [4, 48],
        typeColor: 'left_right',
        GameName: 'lotto 4/48',
      },
    ],
    poolLotto: [
      {
        type: 'solid_inner',
        numbers: [6, 49],
        typeColor: 'right_left',
        GameName: 'Lotto 6/49',
      },
    ],
  };

  const colorBeting = [
    { color: 'purple', selected: false },
    { color: 'limegreen', selected: false },
    { color: 'cyan', selected: false },
    { color: 'royalblue', selected: false },
    { color: 'mediumvioletred', selected: false },
    { color: 'goldenrod', selected: false },
    { color: 'chocolate', selected: false },
    { color: 'dimgray', selected: false },
    { color: 'forestgreen', selected: false },
    { color: 'firebrick', selected: false },
  ];

  const menuItems = [
    [],
    [
      { label: 'Night Mode', type: 'toggle', stateKey: 'nightMode' },
      { label: 'Sound', type: 'toggle', stateKey: 'sound' },
    ],
    [],
    [],
  ];

  //jackPot lotto 6/49

  useEffect(() => {
    if (resultLotto_6_49 && resultLotto_6_49.length > 0) {
      setJackpot((prevJackpot) => prevJackpot + 10);
    }
  }, [resultLotto_6_49]);

  useEffect(() => {
    setPopupOpenStatus(false);
  }, [theme.themeName]);

  return (
    <>
      <Header />
      <div
        className={classes.allCont}
        style={{
          background: nightMode ? theme.nightModeColor : theme.background,
        }}
      >
        <div
          className={`${classes.gameListCont} ${isAnyMenuOpen ? classes.gameListOpen : ''} `}
        >
          <div
            className={`${classes.menuTopSettings} ${isAnyMenuOpen ? classes.menutopSettingOpen : classes.menutopSettingClose} `}
            style={{
              background:
                isMobile || isTablet || nightMode
                  ? theme.selectedColor
                  : theme.backgroundInside,
            }}
          >
            <ul className={classes.menuSetting}>
              {[0, 1, 2].map((index) => {
                if (index === 0 && !isMobile && !isTablet) {
                  return null;
                }

                return (
                  <li
                    key={index}
                    className={`${index === 2 ? classes.linkMenuSetting1 : classes.linkMenuSetting} ${openIndex === index ? classes.active : ''}`}
                    style={{ border: theme.border }}
                    onClick={
                      index === 0
                        ? openmenu
                        : index === 2
                          ? popUpHandle
                          : () => toggleMenu(index)
                    }
                  >
                    {index === 0 && (isMobile || isTablet) && (
                      <div className={classes.burgermenuContainer}>
                        <i
                          className={`${btnstate === 'open' ? classes.openbtn : classes.closebtn}`}
                        ></i>
                        <i
                          className={`${btnstate === 'open' ? classes.openbtn : classes.closebtn}`}
                        ></i>
                        <i
                          className={`${btnstate === 'open' ? classes.openbtn : classes.closebtn}`}
                        ></i>
                      </div>
                    )}
                    {index === 1 && (
                      <FontAwesomeIcon icon={faGear} color="white" />
                    )}
                    {index === 2 && (
                      <img
                        src={howToPlayIcon}
                        alt="howtoplay icon"
                        className={classes.iconStyle}
                      />
                    )}

                    <div
                      className={`${classes.dropdownMenu} ${openIndex === index ? classes.open : ''}`}
                    >
                      <ul
                        style={{
                          background:
                            isMobile || isTablet || nightMode
                              ? theme.selectedColor
                              : theme.backgroundInside,
                        }}
                      >
                        {menuItems[index].map((item, i) => (
                          <li key={i}>
                            {item.stateKey ? (
                              <div
                                className={classes.toggleContainer}
                                onClick={(e) => toggleState(item.stateKey, e)}
                              >
                                {item.label}
                                <div
                                  className={`${classes.toggleSwitch} style={{ '--btnsColor-color': theme.hoverColor }} ${item.stateKey === 'nightMode'
                                    ? nightMode
                                      ? classes.on
                                      : ''
                                    : sound
                                      ? classes.on
                                      : ''
                                    }`}
                                >
                                  <div className={classes.toggleCircle}></div>
                                </div>
                              </div>
                            ) : (
                              item
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div
            className={`${classes.downGames} ${isAnyMenuOpen ? classes.menuOpen : classes.menuClose} ${isMobile || isTablet ? (menulist === 'visible' ? classes.open : classes.close) : ''}`}
            style={{
              background:
                isMobile || isTablet || nightMode
                  ? theme.selectedColor
                  : theme.backgroundInside,
              padding: isMobile || isTablet ? '' : '6px',
            }}
          >
            <GameList
              title="lotto games"
              games={gamesData.lotto}
              onGameClick={(gameName) => handleGameClick(gameName, 'loto')}
              activeGame={activeGame}
              type={gamesData.lotto[0]?.type}
              hoverColor={theme.hoverColor}
              activeColor={theme.hoverColor}
            />
            <GameList
              title="instant loto"
              games={gamesData.instant}
              onGameClick={(gameName) => handleGameClick(gameName, 'instant')}
              activeGame={activeGame}
              type={gamesData.instant[0]?.type}
              hoverColor={theme.hoverColor}
              activeColor={theme.hoverColor}
            />
            <GameList
              title="Pool lotto"
              games={gamesData.poolLotto}
              onGameClick={(gameName) => handleGameClick(gameName, 'poolLotto')}
              activeGame={activeGame}
              type={gamesData.poolLotto[0]?.type}
              hoverColor={theme.hoverColor}
              activeColor={theme.hoverColor}
            />
          </div>
        </div>
        <div className={classes.canvasWithBets}>
          <div className={classes.staticGameCont}>
            <div className={classes.gameSettingContainer}>
              <GameSetting
                maxNumbers={theme.selectedNumbers}
                colorNumbers={colorBeting}
                sound={sound}
                nightMode={nightMode}
              />
            </div>
            <div>
              <GameBets
                nightMode={nightMode}
                resultPick3={resultPick3}
                resultLotto_4_48={resultLotto_4_48}
                resultLotto_5_90={resultLotto_5_90}
                resultLotto_6_49={resultLotto_6_49}
              />
            </div>
            <div className={classes.GameStaticsContainer}>
              <GameTickets activeGame={activeGame} nightMode={nightMode} />
            </div>
            {isMobile ? (
              <div className={classes.specialbetsCont}>
                <SpecialBets colorNumbers={colorBeting} nightMode={nightMode} />
              </div>
            ) : (
              ''
            )}
          </div>
          <div className={classes.canvasSpecialCont}>
            <div className={classes.canvasCont}>
              <button
                onClick={() => {
                  if (!isUserInteracted) {
                    handleUserInteraction();
                  } else {
                    setSound((prevSound) => !prevSound);
                  }
                }}
                className={classes.muteBtnSound}
              >
                <FontAwesomeIcon
                  icon={sound && isUserInteracted ? faVolumeUp : faVolumeMute}
                  className={classes.audioIcon}
                />
              </button>

              <div className={classes.bothConts}>
                <div className={classes.counterPosition}>
                  <CounterComponent />
                </div>

                {theme.themeName === 'Lotto 6/49' && (
                  <div className={classes.jackPotPosition}>
                    <div className={classes.priceJackPotContainer}>
                      <span
                        className={classes.jackpotInside}
                        style={{ color: theme.selectedColor }}
                      >
                        {jackpot}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <LottoCanvas sound={sound} isUserInteracted={isUserInteracted} />
            </div>

            {isMobile ? (
              ''
            ) : (
              <div className={classes.specialbetsCont}>
                <SpecialBets colorNumbers={colorBeting} nightMode={nightMode} />
              </div>
            )}
          </div>
        </div>
      </div>
      {isPopupOpenStatus && (
        <PopupComponent
          popUpstatus={true}
          onClose={() => setPopupOpenStatus(false)}
          draws={draws}
          resultPick3={resultPick3}
          resultLotto_4_48={resultLotto_4_48}
          resultLotto_5_90={resultLotto_5_90}
          resultLotto_6_49={resultLotto_6_49}
          paddingCont="resultStatus"
        />
      )}
      {isPopupOpen && (
        <PopupComponent
          onClose={() => setPopupOpen(false)}
          popUpstatus={false}
        />
      )}

      <Footer />
    </>
  );
}

export default LotteryHomePage;
